import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Text from '../../assets/styles/Text';
import Spinner from '../../assets/styles/spinner';

export default function PaymentCheckout() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const invoiceUrl = state?.invoiceUrl;

  useEffect(() => {
    if (!invoiceUrl) {
      navigate('/plans', { replace: true });
      return;
    }

    window.open(invoiceUrl, '_blank', 'noopener,noreferrer');
    navigate('/modeldashboard', { replace: true });
  }, [invoiceUrl, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        minHeight: '60vh',
      }}
    >
      <Spinner size={48} />
      <Text.Span>Redirecionando para o pagamento...</Text.Span>
    </div>
  );
}
